var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoodleChefsHatIcon200(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 228.3 218.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{stroke-width:13.71px;}.d,.e{fill:current;stroke:current;}.e{stroke-width:18.28px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M219.16,81.21c0-27.53-22.32-49.85-49.85-49.85-4.38,0-8.6,.62-12.65,1.68-8.76-14.31-24.49-23.9-42.5-23.9s-33.74,9.58-42.5,23.9c-4.05-1.06-8.27-1.68-12.65-1.68-27.53,0-49.85,22.32-49.85,49.85s22.32,49.85,49.85,49.85c.88,14.87-1.08,39.42-4.17,66.08,18.38,8,38.15,12,59.32,12s40.96-4,59.33-12c-3.09-26.66-5.05-51.21-4.17-66.08,27.53,0,49.85-22.32,49.85-49.85Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 96.66,
    y1: 139.32,
    x2: 96.66,
    y2: 179.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 131.64,
    y1: 139.32,
    x2: 131.64,
    y2: 179.73
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoodleChefsHatIcon200);
export default __webpack_public_path__ + "static/media/Phoodle_Chefs-Hat_Icon_200.de47537547e036c6d549ed3d971e9838.svg";
export { ForwardRef as ReactComponent };